import { configureStore } from "@reduxjs/toolkit";
import keycloakSlice from "src/router/authLayer/keycloakSlice";
import aclSlice from "src/router/authLayer/aclSlice";
import themeSlice from "src/router/themeLayer/themeSlice";

const store = configureStore({
    reducer: {
        keycloakReducer: keycloakSlice.reducer,
        aclReducer: aclSlice.reducer,
        themeReducer: themeSlice.reducer
    },
    middleware: (getDefaultMiddleware) =>
        getDefaultMiddleware({
            serializableCheck: {
                ignoredActions: [
                    "keycloakSlice/setKeycloak"
                ],
                ignoredPaths: [
                    "keycloakReducer.keycloak"
                ]
            }
        })

});

export { useDispatch, useSelector } from "react-redux";
export const keycloakActions = keycloakSlice.actions;
export const aclActions = aclSlice.actions;
export const themeActions = themeSlice.actions;
export default store;
